import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const EMPTY = { email: "", first_name: "", last_name: "", role_key: "" };

export const UserCreateDialog = ({ open, onOpenChange, roles, onCreated }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/users", form);
      if (r.data.temp_password) window.prompt("Utente creato. Copia e invia queste credenziali (la password non verrà più mostrata):", `Email: ${form.email} · Password temporanea: ${r.data.temp_password}`);
      toast.success("Utente autorizzato");
      setForm(EMPTY);
      onOpenChange(false);
      onCreated();
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="user-create-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Autorizza utente</DialogTitle>
            <DialogDescription>L'utente potrà accedere con il proprio account Microsoft aziendale. Nessuna password viene creata.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-1.5"><Label className="text-xs">Email aziendale</Label>
              <Input type="email" required maxLength={254} value={form.email} onChange={set("email")} data-testid="user-create-email-input" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5"><Label className="text-xs">Nome</Label><Input maxLength={80} value={form.first_name} onChange={set("first_name")} data-testid="user-create-firstname-input" /></div>
              <div className="space-y-1.5"><Label className="text-xs">Cognome</Label><Input maxLength={80} value={form.last_name} onChange={set("last_name")} data-testid="user-create-lastname-input" /></div>
            </div>
            <div className="space-y-1.5"><Label className="text-xs">Ruolo</Label>
              <Select value={form.role_key} onValueChange={(v) => setForm((f) => ({ ...f, role_key: v }))}>
                <SelectTrigger data-testid="user-create-role-select"><SelectValue placeholder="Seleziona ruolo" /></SelectTrigger>
                <SelectContent>{roles.map((r) => <SelectItem key={r.key} value={r.key} data-testid={`user-create-role-${r.key}`}>{r.name}</SelectItem>)}</SelectContent>
              </Select></div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
            <Button type="submit" disabled={busy || !form.email || !form.role_key} data-testid="user-create-submit-button">Autorizza</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
